exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qmodii .theme--light.v-label{color:rgba(0,0,0,.54)}.qmodii .theme--light.v-label--is-disabled{color:rgba(0,0,0,.38)}.qmodii .theme--dark.v-label{color:hsla(0,0%,100%,.7)}.qmodii .theme--dark.v-label--is-disabled{color:hsla(0,0%,100%,.5)}.qmodii .v-label{font-size:16px;line-height:1;min-height:8px;transition:.3s cubic-bezier(.25,.8,.5,1)}", ""]);

// exports
